import { useTranslation } from 'react-i18next';
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from './ui/card';
import { dateLocale } from '../lib/dateFormat';
import { DateText } from './ui/week-badge';

const RecentTimesheets = ({ timesheets, projects }) => {
  const { t } = useTranslation();
  // Sort timesheets by date descending (newest first)
  const sortedTimesheets = [...timesheets].sort((a, b) => {
    const dateA = new Date(a.date || a.created_at);
    const dateB = new Date(b.date || b.created_at);
    return dateB - dateA;
  });

  return (
    <Card className="bg-white border-0 shadow-sm">
      <CardHeader className="pb-3">
        <CardTitle className="text-base sm:text-lg">{t('auto.misc2.recentTimesheetEntries')}</CardTitle>
        <CardDescription className="text-xs sm:text-sm">{t('auto.misc2.latestTimesheetSubmissions')}</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-2 sm:space-y-4" data-testid="recent-timesheets-list">
          {sortedTimesheets.length === 0 ? (
            <p className="text-slate-500 text-center py-4">{t('auto.misc2.noTimesheetEntriesYet')}</p>
          ) : (
            sortedTimesheets.slice(0, 5).map((timesheet) => (
              <div
                key={timesheet.id}
                className="flex flex-col gap-1 sm:flex-row sm:items-center sm:justify-between sm:gap-3 p-3 sm:p-4 border border-slate-200 rounded-lg"
              >
                <div className="min-w-0">
                  <p className="font-medium text-slate-900 text-sm sm:text-base truncate">
                    {projects.find(p => p.id === timesheet.project_id)?.name || 'Unknown Project'}
                  </p>
                  <p className="text-xs sm:text-sm text-slate-600 line-clamp-2">{timesheet.description}</p>
                </div>
                <div className="flex items-center justify-between gap-3 sm:flex-col sm:items-end sm:justify-start shrink-0">
                  <p className="font-medium text-slate-900 text-sm sm:text-base">{timesheet.hours} hours</p>
                  <p className="text-xs sm:text-sm text-slate-600">
                    <DateText value={timesheet.date} />
                  </p>
                </div>
              </div>
            ))
          )}
        </div>
      </CardContent>
    </Card>
  );
};

export default RecentTimesheets;
